var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip",style:(_vm.tooltipStyle)},[(_vm.copyStatus)?_c('img',{staticStyle:{"margin-right":"2px"},attrs:{"src":"/img/icon_copy.svg","alt":""}}):_vm._e(),(_vm.type === 'status')?_c('span',[_vm._v(_vm._s(_vm.copyStatus ? "클립보드에 복사되었습니다." : "클릭하면 파일명을 클립보드에 저장합니다."))]):_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }